import { Route } from "react-router-dom";
import PaymentAlreadyMade from "../components/pay_now/PaymentAlreadyMade";
import PageNotFound from "../components/pay_now/PageNotFound";
import RenewalSuccess from "../components/pay_now/Success";
import RenewalLinkExpire from "../components/pay_now/RenewalLinkExpire";
import HkSuccess from "../components/pay_now/hk/HkSuccess";
import HKRenewalPolicyDetails from "../components/pay_now/hk/RenewalPolicyDetail";
import SGRenewalPolicyDetails from "../components/pay_now/RenewalPolicyDetails";
import PayNowCancelled from "../components/pay_now/Cancelled";
import RenewalPolicy from "../components/pay_now/RenewalPolicy";

const RenewalPolicyRoute = () => {
  return (
    <>
      <Route path="/policy-details/:renewalId" element={<RenewalPolicy />} />
      <Route path="/payment-already-done" element={<PaymentAlreadyMade />} />
      <Route path="/page-not-found" element={<PageNotFound />} />
      <Route path="/sg/payment/success" element={<RenewalSuccess />} />
      <Route path="/hk/payment/success" element={<HkSuccess />} />
      <Route path="/hk/policy-details" element={<HKRenewalPolicyDetails />} />
      <Route path="/sg/policy-details" element={<SGRenewalPolicyDetails />} />
      <Route path="/sg/payment/cancelled" element={<PayNowCancelled />} />
      <Route path="/hk/payment/cancelled" element={<PayNowCancelled footerType />} />
      <Route path="/renewal-link-expired" element={<RenewalLinkExpire />} />
    </>
  );
};

export default RenewalPolicyRoute;
